import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

type ConfigurationChecker = typeof import('./index').default;
type Props = React.ComponentProps<ConfigurationChecker>;

const LazyAfterPaintConfigurationChecker = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-servicedesk-configuration-checker" */ './index'),
);

const AsyncConfigurationChecker = (props: Props) => (
	<JSErrorBoundary
		id="bundle-async-configuration-checker"
		fallback="unmount"
		packageName="jira-servicedesk-configuration-checker"
		teamName="jsd-shield"
	>
		<Placeholder name="servicedesk-configuration-checker" fallback={<></>}>
			<LazyAfterPaintConfigurationChecker {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncConfigurationChecker;
